import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const DialogBox = ({ isOpen, title, message, buttons, toggle, size, actionsDisabled = false }) => {
    return (
        <Modal isOpen={isOpen} toggle={actionsDisabled ? undefined : toggle} keyboard={!actionsDisabled} centered backdrop="static" size={size}>
            {title && <ModalHeader toggle={actionsDisabled ? undefined : toggle}>{title}</ModalHeader>}
            <ModalBody>{message}</ModalBody>
            <ModalFooter>
                {buttons.map((btn, index) => (
                    <Button                    
                        key={index}
                        outline={btn.outline || false}
                        color={btn.color || 'secondary'}
                        disabled={actionsDisabled || btn.disabled}
                        data-testid={btn.dataTestId}
                        onClick={btn.onClick}
                    >
                        {btn.icon && <i className={`me-2 ${btn.icon}`}></i>}
                        {btn.label}
                    </Button>
                ))}
            </ModalFooter>
        </Modal>
    );
};

export default DialogBox;